import React from "react";
import "../designcss/Whatsappautomation.css"

const Personalisedautomation = () => {
  return (
    <>
      <section className="whatsappautomation">
        <div className="helpbusiness">
          <h1>How Does it Tailored Messaging</h1>
          <h1>for Business Goals</h1>
        </div>

        <p className="marketingsystem">
          For sales and promotions, personalized WhatsApp messages allow brands
          to share relevant offers and product suggestions based on past
          interactions, helping increase conversions compared to generic
          broadcasts.
        </p>

        <div className="cardss-wrapperr">
          <div className="infoo-cardd">
            <h3>Easy Customization and Automation</h3>
            <p>
              WoSender combines smart automation with personalization, enabling
              businesses to send messages that feel human and conversational
              while saving time and resources.
            </p>
          </div>

          <div className="infoo-cardd">
            <h3>Insight-Driven Messaging</h3>
            <p>
              Leverage customer behavior, preferences, and interaction history
              to deliver timely, relevant, and impactful messages that drive
              meaningful engagement.
            </p>
          </div>

          <div className="infoo-cardd">
            <h3>Scale Communication Seamlessly</h3>
            <p>
              Whether communicating with hundreds or thousands of users,
              WoSender ensures personalized messages reach every customer
              without compromising quality or relevance.
            </p>
          </div>

          <div className="infoo-cardd">
            <h3>Turn Conversations into Conversions</h3>
            <p>
              Targeted, personalized WhatsApp messages help guide customers from
              interest to action, boosting sales and fostering long-term
              loyalty.
            </p>
          </div>

          <div className="infoo-cardd">
            <h3>Seamless Customer Engagement</h3>
            <p>
              WoSender ensures every interaction feels personal and relevant,
              keeping customers engaged throughout their journey and
              strengthening brand relationships.
            </p>
          </div>

          <div className="infoo-cardd">
            <h3>Enhanced ROI Through Targeted Messaging</h3>
            <p>
              By sending messages that truly resonate with your audience,
              WoSender helps businesses improve response rates, increase
              conversions, and maximize marketing ROI.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Personalisedautomation;
